export default () => ({
  cancelingOrder: false,
  gettingOrders: false,
  orders: {},
  sendingOrder: false,
});
